/* eslint-disable quotes */
/* eslint-disable max-len */
import { EventEmitter, Injectable } from '@angular/core';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { DispatchBoardService } from '../../../../../dispatch-board/src/app/components/dispatch-board/dispatch-board.service'; 
import _ from 'lodash';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { BadgeOptions, badgeColorCode } from 'app/components/badge/badge.interface';
import { TitleCasePipe } from '@angular/common';
import { DateTimePipe } from 'app/core/pipes/datetimeformator.pipe';
import { DateFormatPipe } from 'app/core/pipes/dateFormat.pipe';
import dayjs from 'dayjs';
import { TimeFormatPipe } from 'app/core/pipes/timeFormat.pipe';
import moment from 'moment';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { DateHelper } from '@bryntum/core-thin';
import { CalendarService } from '../../components/services/calendar.service';
import { serviceContractStatus } from 'app/components/datagrid/datagrid.interface';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  metaData: any;
  gridData: any;
  singletonRows = ['work_order_scheduled_date@Scheduled-Date-&-Time', 'employee_name@Technician-Name'];
  userPreferences: any;
  objectKeys = Object.keys;
  timeSheetValue: { punchedIn: string; punchedOut: string };
  capacityHours: { hours: number; minutes: number } = null;
  fieldsVisibility: any = null;
  dateRange: { fromDate: string; toDate: string } = null;
  userDetails: any = null;
  preferences: any = null;
  viewMode: string = null;
  previewEmitter: EventEmitter<any> = new EventEmitter();
  defaultMonthGridCardView = { '1': [{ 'label': 'Job Title', 'originalLabel': 'Job Title', 'group_uid': 'work_order_title', 'group_name': 'Default Fields', 'type': 'SINGLE_LINE', 'value': 'Skiles and Sons', 'selector': 'job_title', 'dismissable': true, 'isDefaultField': true, 'key': 'work_order_title@Job-Title', 'row': 1, 'column': 2 }] };
  constructor(
    private _dispatchBoardService: DispatchBoardService,
    private _localStorageService: LocalStorageService,
    private _utilityService: UtilityService,
    private titlecasePipe: TitleCasePipe,
    private dateTimePipe: DateTimePipe,
    private dateFormatPipe: DateFormatPipe,
    private timePipe: TimeFormatPipe,
    private _dataCollectorService: DataCollectorService,
    private calendarService: CalendarService
  ) {
    this.userPreferences = this._localStorageService.getLocalStorage('user_preferences');
  }

  getJobRendererTemplate(tab: 'jobs', type: TemplateType, jobUid?: string, eventRecord?: any, viewMode?:string): string {
    if(type === 'calendar') {
      this.metaData = this._localStorageService.getLocalStorage('calendar_metadata');
    }
    const hideValues: any[] = [null, undefined, NaN, '',];
    const skipHideChecks: any[] = ['total_jobs'];
    let jobDetails: any;
    let cardDetails: any = {};
    let startRowNumber: number = 1;
    let customSelectedAttributes: any;
    let primaryColor: string = '#e67e22';
    let secondaryColor: string = '#393a3c';
    let templateHtml: string = '';
    let primaryColorTooltip = '';
    let secondaryColorTooltip = '';
    const skipAttributeIcon: any[] = [];
    const colorRep: any = {
      'jobStatus': this._utilityService.getLocaleValue('text.job_status'),
      'team': this._utilityService.getLocaleValue('text.team'),
      'jobCategory': this._utilityService.getLocaleValue('dispatchBoard.settings.color_options.job_category'),
      'jobPriority': this._utilityService.getLocaleValue('dispatchBoard.settings.color_options.job_priority'),
    };

    /* eslint-disable @typescript-eslint/naming-convention */
    if (jobUid && type === 'calendar') {
      const metaCalendarData = this._localStorageService.getLocalStorage('calendar_metadata');
      let calendarRecords: any;
      if (tab === 'jobs') {
        calendarRecords = this._dispatchBoardService.getCalendarRecords();
        jobDetails = _.find(calendarRecords, { 'job_uid': jobUid });
      }
      if(viewMode === 'month'){
        if (this._utilityService.isEmptyOrUndefined(metaCalendarData?.calendar?.month_card_view)) {
          customSelectedAttributes = this.defaultMonthGridCardView;
        } else{
          customSelectedAttributes = metaCalendarData?.calendar?.month_card_view;
        }
      } else{
        customSelectedAttributes =  metaCalendarData?.calendar?.card_view;
      }
      if (this._utilityService.isEmptyOrUndefined(jobDetails)) {
        if (tab === 'jobs') {
          const _gridRecords = this._dispatchBoardService.getGridRecords();
          jobDetails = _.find(_gridRecords, { 'job_uid': jobUid });
        }
      }
      cardDetails = this.calendarService.formatJobDetails(customSelectedAttributes, jobDetails);
    }
    /* eslint-enable @typescript-eslint/naming-convention */
    if (!this._utilityService.isEmptyOrUndefined(customSelectedAttributes) && !this._utilityService.isEmptyOrUndefined(cardDetails)) {
      if (type === 'calendar') {
        templateHtml += `<div class='font-normal primary-font text-base text-gray-700'>`;
      }

      for (let row = startRowNumber; row <= Object.keys(customSelectedAttributes).length; row += 1) {
        templateHtml += `<div class='flex items-center gap-3 data-items'>`;
        _.forEach(customSelectedAttributes[row], (attribute: any, column: number) => {
          if ((!hideValues.includes(cardDetails[attribute.key]) && cardDetails[attribute.key]) || skipHideChecks.includes(attribute.group_uid)) {
            templateHtml += `<div class='flex items-center' ${this.singletonRows.includes(attribute.key) ? `style='max-width: 100% !important'` : ''}>`;
            if (attribute.isDefaultField) {
              templateHtml += `<div class='flex items-center w-full'>`;
              if (!!attribute.icon) {
                if (attribute.group_uid === 'work_order_assigned_to') {
                  if (cardDetails[attribute.key]['count'] === 0 || cardDetails[attribute.key]['count'] < 0) {
                    templateHtml += `<i class="ti ti-user text-lg mr-1"></i>`;
                  }
                  else if (cardDetails[attribute.key]['count'] >= 1) {
                    templateHtml += `<i class="ti ti-users text-lg mr-1"></i>`;
                  }
                }
                else if (!skipAttributeIcon.includes(attribute.group_uid)) {
                  if(attribute.key !== 'job_tags@Tags' || (attribute.key === 'job_tags@Tags' && cardDetails[attribute.key]?.length > 0)){
                    templateHtml += `<i class="${attribute.icon} text-lg mr-1"></i>`;
                  }
                }
              }
              switch (attribute.group_uid) {
                case 'current_work_order_status': {
                  const jobStatusBadge: BadgeOptions = {
                    type: cardDetails[attribute.key],
                    color: cardDetails['status_color_selector'],
                    displayName: cardDetails[attribute.key],
                    extraClass: 'w-inherit block-important rounded'
                  };

                  templateHtml += this.getBadgeTemplate('badge', jobStatusBadge.displayName, jobStatusBadge.color, jobStatusBadge.extraClass);
                }
                case 'work_order_skillsets':
                case 'employee_skillset': 
                  {
                    templateHtml += `<div class='flex gap-2'>`;
                    if (cardDetails[attribute.key]['skill_name']) {
                      const skillsetBadge = {
                        displayKey: `${cardDetails[attribute.key]['skill_name']}` + (cardDetails[attribute.key]['skill_count']
                          ? ` + ${cardDetails[attribute.key]['skill_count']} ${this._utilityService.getLocaleValue('text.more')}`
                          : '')
                      };

                      templateHtml += `${this.getBadgeTemplate('tag', skillsetBadge.displayKey)}`;
                    }
                    templateHtml += `</div>`;
                    break;
                  }
                case 'work_order_assigned_to': {
                  templateHtml += `<div class='flex items-center'>`;
                  if (cardDetails[attribute.key] && cardDetails[attribute.key]['count'] >= 0) {
                    let usersNames = '';
                    const assignedTo = cardDetails[attribute.key]['assignedTo'];
                    if (assignedTo && assignedTo.length > 0) {
                      usersNames = assignedTo.map(user => user.name).join(', ');
                    }
                    templateHtml += `<span class="job-card-overflow" title='${attribute.displayKeyValue}: ${usersNames}'>${usersNames}</span>`;
                  }
                  if (cardDetails[attribute.key]['count'] < 0) {
                    templateHtml += `<span>--</span>`;
                  }
                  templateHtml += `</div>`;
                  break;
                }
                case 'work_order_priority': {
                  const priorityColor = badgeColorCode[cardDetails[attribute.key]] || '#ffffff';
                  templateHtml += `<div class ='flex items-center gap-1'><div class='w-3 h-3 rounded-full' style='background-color:${priorityColor};'></div>
                  <span class='overflow-hidden whitespace-nowrap text-ellipsis w-fit' title="${attribute.displayKeyValue} : ${this.titlecasePipe.transform(cardDetails[attribute.key])}">${this.titlecasePipe.transform(cardDetails[attribute.key])}</span></div>`;
                  break;
                }
                case 'work_order_actual_date':
                case 'work_order_scheduled_date': {
                  let startDate;
                  let checkStartDate;
                  let checkEndDate;
                  let endDate;
                  let startTime;
                  let endTime;
                  let scheduledStartDate;
                  if (attribute.group_uid === 'work_order_actual_date') {
                    scheduledStartDate = this.getStartEndTime(eventRecord?.actual_start_time, eventRecord?.actual_end_time, this._utilityService.preferredTimeZone);
                  } else {
                    scheduledStartDate = this.getStartEndTime(eventRecord?.scheduled_start_time, eventRecord?.scheduled_end_time, this._utilityService.preferredTimeZone);
                  }
                  if (cardDetails[attribute.key]) {
                    let formattedDate: string = '';
                    if (cardDetails[attribute.key]['startDateTime']) {
                      formattedDate += scheduledStartDate;
                      templateHtml += `<div class="flex gap-2 text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis w-fit"><span title="${attribute.displayKeyValue} : ${formattedDate}"
                      class=" flex items-center overflow-hidden whitespace-nowrap text-ellipsis w-fit">${formattedDate}</div>`;
                    }
                  }
                  break;
                }
                case 'total_jobs': {
                  templateHtml += `<span title="${attribute.displayKeyValue} : ${cardDetails[attribute.key]}"
                    class="text-base font-normal text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis w-fit">
                    ${cardDetails[attribute.key]}</span>`;
                  break;
                }
                case 'job_tags': {
                  if (cardDetails[attribute.key]?.length) {
                    let extraTagCount: number = 0;
                    const tagsFormatted = cardDetails[attribute.key]?.join(', ');
                    if (cardDetails[attribute.key]?.length > 1) {
                      extraTagCount = cardDetails[attribute.key]?.length - 1;
                    }
                    templateHtml += `<div class='p-1.5 w-fit truncate block text-base rounded bg-gray-200 text-gay-700' title="${attribute.displayKeyValue}: ${tagsFormatted}">${cardDetails[attribute.key][0]} ${extraTagCount ? `+ ${extraTagCount} ${this._utilityService.getLocaleValue('text.more')}`: ''}</div>`;
                  }
                  break;
                }
                default: {
                  templateHtml += `<span title="${attribute.displayKeyValue} : ${cardDetails[attribute.key]}"
                class="${(attribute.group_uid === 'work_order_number' || attribute.group_uid === 'work_order_title') ? 'font-semibold' : 'font-normal'} text-base font-normal text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis w-fit">
                ${cardDetails[attribute.key]}
                </span>`;
                  if (attribute.group_uid === 'work_order_title' && cardDetails['routeDetails'].isRouteJob) {
                    templateHtml += `<em title="${this._utilityService.getLocaleValue('dispatchBoard.template.grid.route_job')}: ${cardDetails['routeDetails'].routeName}" class="ti ti-road text-lg text-blue-700 ml-1"></em>`;
                  }
                  if (attribute.group_uid === 'work_order_title' && cardDetails['is_recurrence']) {
                    templateHtml += `<em title="${this._utilityService.getLocaleValue('text.recurrent_job')}" class="ti ti-repeat text-lg text-blue-700 ml-1"></em>`;
                  }
                  if (attribute.group_uid === 'work_order_title' && cardDetails['delayed_job']) {
                    templateHtml += `<em title="${this._utilityService.getLocaleValue('dispatchBoard.template.grid.delay_job')}" class="ti ti-alarm text-lg text-red-700 ml-1"></em>`;
                  }
                }
              }
              templateHtml += `</div>`;
            }
            else {
              templateHtml += `${cardDetails[attribute.key]['href'] ?
                `<span class='overflow-hidden whitespace-nowrap text-ellipsis w-fit my-1' title="${attribute.displayKeyValue}"'> <a class="w-10/12 text-justify text-primary-500 hover:underline font-normal text-base" 
             href="${cardDetails[attribute.key]['href']}" onclick="event.stopPropagation()" target="_blank">${attribute.type === 'LOOKUP' ? cardDetails[attribute.key]['value'] : this._utilityService.getLocaleValue('dispatch.template.field.view_link')}</a></span>` :
                `<span class="overflow-hidden whitespace-nowrap text-ellipsis w-fit" title="${attribute.tooltip}: ${cardDetails[attribute.key]}"> ${cardDetails[attribute.key]}</span>`
                }`;
            }
            templateHtml += `</div>`;
          } else{
            if(viewMode === 'month'){
              templateHtml += `--`;
            } else{
              templateHtml += ``;
            }
          }
        });
        templateHtml += '</div>';
      }

      templateHtml += '</div>';
    }
    else {
      templateHtml = '';
    }
    return templateHtml;
  }

  getBadgeTemplate(type: 'badge' | 'tag', displayName: any, color?: string, extraClass?: string): string {
    if (!type || !displayName) { return ''; }
    if (type === 'badge') {
      const backgroundColor: string = this._utilityService.convertHexToRgba(color);
      return `<div class="truncate w-inherit block-important w-max-fit">
        <div class="border leading-none p-0.5 pt-1 px-2.5 w-inherit inline-block truncate ${extraClass ? extraClass : 'rounded-2xl'} flex items-center justify-center" title="${displayName}" style="color: ${color}; background: ${backgroundColor}; border-color: ${color}">${displayName}</div>
      </div>`;
    }
    else if (type === 'tag') {
      return `<div class="truncate w-inherit block-important w-max-fit">
        <div class="border p-1 px-2.5 w-inherit inline-block truncate rounded bg-gray-200 text-gray-700" title="${displayName}">${displayName}</div>
      </div>`;
    }
  }

  getNonJobEventRendererTemplate(nonJobEventDetails: any, viewMode: string): any {
    const eventName: string = nonJobEventDetails?.event_name || '';
    const startEndTime: any[] = this._dispatchBoardService.getStartEndTime(nonJobEventDetails?.start_time, nonJobEventDetails?.end_time, false, null, true);
    const categoryColor: string = nonJobEventDetails?.event_category?.category_color || '#e67e22';
    const availabilityFree: boolean = nonJobEventDetails?.is_available;
    const isRecurrence: boolean = nonJobEventDetails?.is_recurrence;
    let templateHTML: string = '';
    
    if (viewMode === 'MONTH') {
      templateHTML += `
        <div class="w-full h-full text-gray-700 pr-1 month-view-card">
          <div class="flex w-full h-full items-center">
            <div class="w-1.5 h-6 flex-shrink-0" style="${availabilityFree ? `background-image: linear-gradient(135deg, ${categoryColor} 25%, #ffffff 25%, #ffffff 50%, ${categoryColor} 50%, ${categoryColor} 75%, #ffffff 75%, #ffffff 100%); background-size: 11.31px 11.31px` : `background: ${categoryColor}`};"></div>
            <div class="flex flex-1 items-center justify-between h-full primary-font text-base font-normal pl-1">
              <div class="flex items-center truncate" title="${this._utilityService.getLocaleValue('non_job_event.create.name')}: ${eventName}">
                <span class="block truncate">${eventName}</span>
                ${isRecurrence ? `<i class="ti ti-repeat text-2xl ml-2" style='color: #0172CB' title="${this._utilityService.getLocaleValue('text.recurrence_event')}"></i>` : ''}
              </div>
              <div class="flex items-center space-x-1 truncate" title="${this._utilityService.getLocaleValue('text.event_schedule')}: ${startEndTime[0]} -> ${startEndTime[1]}">
                <i class="ti ti-calendar-time text-2xl"></i>
                <span>${startEndTime[0]}</span>
                <i class="ti ti-arrow-right text-2xl"></i>
                <span>${startEndTime[1]}</span>
              </div>
            </div>
          </div>
        </div>`;
    } else {
      templateHTML += `
        <div class="w-full h-full text-gray-700 pr-1">
          <div class="flex w-full h-full items-center">
            <div class="h-full w-1.5 flex-shrink-0" style="${availabilityFree ? `background-image: linear-gradient(135deg, ${categoryColor} 25%, #ffffff 25%, #ffffff 50%, ${categoryColor} 50%, ${categoryColor} 75%, #ffffff 75%, #ffffff 100%); background-size: 11.31px 11.31px` : `background: ${categoryColor}`};"></div>
            <div class="w-full h-full primary-font text-base font-normal p-1.5 space-y-1.5">
              <div class="flex justify-between items-center truncate" title="${this._utilityService.getLocaleValue('non_job_event.create.name')}: ${eventName}">
                <span class="block truncate">${eventName}</span>
                ${isRecurrence ? `<i class="ti ti-repeat text-2xl" style='color: #0172CB' title="${this._utilityService.getLocaleValue('text.recurrence_event')}"></i>` : ''}
              </div>
              <div class="flex items-center space-x-1 truncate" title="${this._utilityService.getLocaleValue('text.event_schedule')}: ${startEndTime[0]} -> ${startEndTime[1]}">
                <i class="ti ti-calendar-time text-2xl"></i>
                <span>${startEndTime[0]}</span>
                <i class="ti ti-arrow-right text-2xl"></i>
                <span>${startEndTime[1]}</span>
              </div>
            </div>
          </div>
        </div>`;
    }
    return templateHTML;
  }  

  getTimeOffHolidayTemplate(type,details): any{
    let template = '';
    switch (type) {
      case 'timeoff':
        template = `<div class="font-normal primary-font text-base text-gray-700">
        <div class="flex items-center gap-3 data-items">
            <div class="flex items-center my-1">
                <div class="flex items-center w-full"><span style="color: white !important;"
                        class="font-semibold text-base font-normal text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis w-fit">
                        #${details.requested_by.emp_code}
                    </span></div>
            </div>
            <div class="flex items-center my-1">
                <div class="flex items-center w-full"><span style="color: white !important;"
                        class="font-semibold text-base font-normal text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis w-fit">
                        ${details.requested_by.first_name} ${details.requested_by.last_name}${details.no_of_days > 1 ? ' (' + details.no_of_days + ' days)' : ''}
                    </span></div>
            </div>
        </div>
    </div>`;
        break;
        case 'holiday':
          template = `<div class="font-normal primary-font text-base text-gray-700">
          <div class="flex items-center gap-3 data-items">
              <div class="flex items-center my-1">
                  <div class="flex items-center w-full"><span style="color: white !important;"
                          class="font-semibold text-base font-normal text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis w-fit">
                          ${details.holiday_name}
                      </span></div>
              </div>
          </div>
      </div>`;
        break;
    };
    return template;
  }

  getJobCalendarRendererTemplate(tab: 'jobs'| 'routes', type: TemplateType, jobUid?: string, jobData?:any): string {
    this.metaData = this._localStorageService.getLocalStorage('calendar_metadata');
    const hideValues: any[] = [null, undefined, NaN, '',];
    let jobDetails: any;
    let cardDetails: any = {};
    const startRowNumber: number = 1;
    let customSelectedAttributes: any;
    let templateHtml: string = '';
    const skipAttributeIcon: any[] = [];

    /* eslint-disable @typescript-eslint/naming-convention */
if (jobUid && type === 'calendar') {
      let schedulerRecords: any;
      if(tab === 'jobs') {
        schedulerRecords = this._dispatchBoardService.getCalendarRecords();
      }
      customSelectedAttributes = this.metaData?.calendar?.card_view;
      jobDetails = _.find(schedulerRecords, { 'job_uid': jobUid });
      if (this._utilityService.isEmptyOrUndefined(jobDetails)) {
        const _gridRecords = this._dispatchBoardService.getGridRecords();
        jobDetails = _.find(_gridRecords, { 'job_uid': jobUid });
      }
      cardDetails = this.calendarService.formatJobDetails(customSelectedAttributes, jobDetails);
      if(jobData){
        let formattedDate: string = '';
      const startTime = moment(jobData.scheduled_start_time).format(this._utilityService.timeFormat);
      const endTime = moment(jobData.scheduled_end_time).format(this._utilityService.timeFormat);
      formattedDate += startTime + ' - ' + endTime;
       templateHtml += `<span class='font-normal text-base text-gray-700'>${formattedDate}</span>`;
      }
    }

    if (cardDetails  && cardDetails['is_recurrence']) {
      templateHtml += `<em title="${this._utilityService.getLocaleValue('text.recurrent_job')}" class="ti ti-repeat text-2xl text-blue-700 ml-2"></em>`;
    }
    /* eslint-enable @typescript-eslint/naming-convention */
    if (!this._utilityService.isEmptyOrUndefined(customSelectedAttributes) && !this._utilityService.isEmptyOrUndefined(cardDetails)) {
        templateHtml += `<div class='font-normal text-base text-gray-700'> #${jobDetails.prefix ?? ''}${jobDetails.work_order_number} ${jobDetails.job_title}</div>`;
    }
    else {
      templateHtml = '';
    }
    return templateHtml;
  }

  getTimeoffTooltipTemplate(userDetails: any, timeoff: any): string {
    const employeeName = userDetails?.name;
    const profileUrl = userDetails?.imageUrl;
    const contactNumber = userDetails?.work_phone_number || userDetails?.home_phone_number || userDetails?.mobile_phone_number;
    const emailId = userDetails?.email;
    const role = timeoff?.role;
    const [timeoffRequestedFrom, timeoffRequestedfromTo] = this._dispatchBoardService.getStartEndTime(timeoff?.actualRequestFrom, timeoff?.actualRequestTo, true);
    const status = timeoff?.status;
    const reason = timeoff?.reason;
    const remarks = timeoff?.remarks;

    let templateHtml = `<div class="w-full h-full overflow-hidden"> <div class="flex items-center justify-between mb-2"><div class="flex justify-center items-center gap-2">`;
    if (this._utilityService.hasValidProfilePicture(profileUrl)) {
      templateHtml += `<div class="mr-2 h-16 w-16" title="${employeeName}">
    <img class="rounded-lg h-16 w-16" src="${profileUrl}" alt="profile_picture" loading="lazy">
    </div>`;
    }
    else {
      templateHtml += `<div class="flex flex-0 items-center justify-center w-16 h-16 rounded-full overflow-hidden" title="${employeeName}">
    <div class="flex items-center justify-center w-full h-full rounded-md text-2xl uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
      ${employeeName?.slice(0, 1)} </div>
    </div>`;
    }
    templateHtml += `<div class='grid gap-0.5'><span class="font-medium tracking-wide text-lg">${employeeName}</span><span class="text-base text-gray-400">${role}</span></div></div><div class='flex gap-1'>`;
    if (contactNumber) {
      templateHtml += `<div class="flex gap-1"><a type='button' href='tel:${contactNumber}' class="text-lg font-normal text-gray-800 flex items-center justify-center gap-1 hover:bg-gray-100 rounded-lg h-8 w-8"><i class="ti ti-phone text-xl font-normal"></i></a></div>`;
    }
    if (!this._utilityService.isEmptyOrUndefined(emailId)) {
      templateHtml += `<div class="flex gap-1"><a type='button' href='mailto:${emailId}' class="text-lg font-normal text-gray-800 flex items-center justify-center gap-1 hover:bg-gray-100 rounded-lg h-8 w-8"><i class="ti ti-mail text-xl font-normal"></i></a></div>`;
    }
    templateHtml += `</div></div><hr>`;
    templateHtml += `<div class='w-full pt-2'><span class='text-base font-semibold text-gray-700 tracking-wide'>${this._utilityService.getLocaleValue('dispatchBoard.scheduler.timeoff.tooltip.details')}</span></div>`;
    templateHtml += `<div class="flex flex-col justify-content my-2 space-y-2">
    <div class="flex flex-wrap items-center flex-row "><i class="ti ti-calendar text-2xl"></i>
    <div class="text-base mt-1 ml-1 flex items-center"><span>${timeoffRequestedFrom}</span><em class="ti ti-arrow-narrow-right text-xl mx-1"></em><span>${timeoffRequestedfromTo}</span></div></div>`;

    if (!this._utilityService.isEmptyOrUndefined(status)) {
      const timeoffStatusBadgeConfig: any = {
        type: status,
        displayName: this.titlecasePipe.transform(status),
        extraClass: 'text-xs'
      };
      templateHtml += `<div class="flex flex-row gap-4">
      <span class="w-1/4 text-base font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.timeoff.tooltip.status', 'Status')}</span>
      <span class="w-full text-base"><badge-template options='${JSON.stringify(timeoffStatusBadgeConfig)}'"></badge-template></span>
      </div>`;
    }
    if (!this._utilityService.isEmptyOrUndefined(reason)) {
      templateHtml += `<div class="flex flex-row gap-4"><span class="w-1/4 text-base font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.timeoff.tooltip.reason', 'Reason')}</span>
      <span class="w-full text-base">${this.titlecasePipe.transform(reason)}</span></div>`;
    }
    if (!this._utilityService.isEmptyOrUndefined(remarks)) {
      templateHtml += `<div class="flex flex-row gap-4"><span class="w-1/4 text-base font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.timeoff.tooltip.remarks', 'Remarks')}</span>
      <span class="w-full text-base multiline-ellipsis">${remarks}</span></div>`;
    }

    templateHtml += `</div></div>`;
    return templateHtml;
  }

  getSchedulerSummaryTooltip(type: 'job' | 'route', resoureAssignments: any, totalEvents: number): string {
    let schedulerTitle: string = '';
    let schedulerSubTitle: string = '';
    if (type === 'job') {
      schedulerTitle = this._utilityService.getLocaleValue('text.job_summary', 'Job Summary');
      schedulerSubTitle = this._utilityService.getLocaleValue('text.total_jobs', 'Total Jobs');
    }
    else if (type === 'route') {
      schedulerTitle = this._utilityService.getLocaleValue('text.route_summary', 'Route Summary');
      schedulerSubTitle = this._utilityService.getLocaleValue('dispatchBoard.scheduler.job.summary.total_routes', 'Total Routes');
    }
    let templateHtml = '';
    templateHtml += `<div class="w-full h-full cursor-pointer">
      <div class="space-y-2">
          <div class="pb-1 font-semibold text-lg border-b border-gray-300">${schedulerTitle}</div>
          <div class="flex items-center cursor-pointer space-x-1">
              <div class="font-medium text-lg">${schedulerSubTitle} :</div> <span class="text-lg font-normal ">${totalEvents}</span>
          </div>`;
    Object.keys(resoureAssignments).forEach((user: any) => {
      templateHtml += `<div class="flex items-center text-lg font-normal space-x-1">`;
      templateHtml += `<i class="text-xl ti ti-user"></i><span>${user} :</span><span>${resoureAssignments[user]}</span>`;
      templateHtml += `</div>`;
    });
    templateHtml += `</div>`;
    templateHtml += `</div>`;
    return templateHtml;
  }

  getSchedulerResourceHeader(filterCount: number, tab: string): string {
    const templateHtml = `<div class="w-full h-full pt-2 text-gray-700">
    <div class="flex items-center justify-between space-x-4">
        <div class="flex">
            <span class="text-xl font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.employee.header', 'Users')}</span>
        </div>
        <div class="flex ml-3">
            <button title="${this._utilityService.getLocaleValue('dispatchBoard.icons.tooltip.search', 'Search')}" id='schedulerEmpHeaderSearchBtn-${tab}' class="hover:bg-gray-100 hover:text-gray-900 rounded-lg h-10 p-2"><i class="ti ti-search text-3xl"></i></button>
            <button  title="${this._utilityService.getLocaleValue('text.filters', 'Filters')}" id='schedulerEmpHeaderFilterBtn-${tab}' class="hover:bg-gray-100 hover:text-gray-900 rounded-lg h-10 p-2  relative inline-flex items-center"><i class="ti ti-filter ${filterCount > 0 ? 'filterIcon' : ''}" style="${filterCount === 0 ? 'font-size: 22px !important;' : ''}"></i>
            <div id="employeeFilterBadge-${tab}" class="absolute inline-flex items-center opacity-0 justify-center w-6 h-6 text-xs font-bold text-white bg-primary-600 border-2 border-white rounded-full top-0 -right-1 dark:border-gray-900">${filterCount}</div>
            </button>
            <button title="${this._utilityService.getLocaleValue('dispatchBoard.icons.tooltip.settings', 'Settings')}" id='schedulerEmpHeaderSettingsBtn-${tab}' class="hover:bg-gray-100 hover:text-gray-900 rounded-lg h-10 p-2"><i class="ti ti-settings text-3xl"></i></button>
        </div>
      </div>
    </div>`;
    return templateHtml;
  }

  getOutOfShiftHoursTooltip(shiftDetails: any): string {
    let templateHtml = ` <div>
        <div class="h-5 p-4 mb-2 flex items-center justify-center border-b border-gray-300">
            <span class="text-base font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.out_of_shift_hours.tooltip.title', 'Out of Shift Hours')}</span>
        </div>
        <div class="flex flex-col space-y-2">
            <span class="text-base font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.out_of_shift_hours.tooltip.details', 'Shift details')}</span>`;
    shiftDetails.forEach((shiftDetail: any, index: number) => {
      const shiftLabel = shiftDetail[0];
      const [startDateTime, endDateTime] = this._dispatchBoardService.getStartEndTime(shiftDetail[1], shiftDetail[2], true);
      templateHtml += `<div class="flex items-center space-x-1"><i class="ti ti-calendar-stats text-2xl"></i>
                <span class="text-base font-normal" title="${this._utilityService.getLocaleValue('dispatchBoard.scheduler.out_of_shift_hours.tooltip.shift_name', 'Shift Name')}">${shiftLabel}</span></div>
                <div class="text-base font-normal flex items-center" title="${this._utilityService.getLocaleValue('text.shift_hours', 'Shift Hours')}"><i class="ti ti-clock text-2xl mr-1"></i><span>${startDateTime}</span> <i class='ti ti-arrow-narrow-right text-xl mx-1'></i><span> ${endDateTime}</span></div> ${index !== shiftDetails.length - 1 ? '<hr>' : ''}`;
    });
    templateHtml += `</div>`;
    return templateHtml;
  }

  getAllDayEventTemplate(type,details): any{
    let templateHtml = '';
    switch (type) {
      case 'timeoff':
        const userDetails = details.requested_by;
        const employeeName = userDetails?.first_name +' '+ userDetails?.last_name;
        const profileUrl = userDetails?.profile_picture;
        const contactNumber = userDetails?.work_phone_number || userDetails?.home_phone_number || userDetails?.mobile_phone_number;
        const emailId = userDetails?.email;
        const role = userDetails?.designation;
        const userRole = this._localStorageService.getLocalStorage('user')?.role.role_key || '';
        const [timeoffRequestedFrom, timeoffRequestedfromTo] = this.calendarService.getStartEndTime(details?.request_from, details?.request_to);
        const status = details?.approval_status;
        const reason = details?.request_reason;
        const remarks = details?.request_remarks;
        const hasPermissionToEditTimeoff = userRole === 'ADMIN' || this._utilityService.hasPermission('timesheet.manage_timeoff') || this._utilityService.user?.user_uid === details?.requestedBy?.user_uid;
        templateHtml = `<div class="w-full h-full overflow-hidden"> <div class="flex items-center justify-between mb-2"><div class="flex justify-center items-center gap-2">`;
        if (this._utilityService.hasValidProfilePicture(profileUrl)) {
          templateHtml += `<div class="mr-2 h-16 w-16" title="${employeeName}">
        <img class="rounded-lg h-16 w-16" src="${profileUrl}" alt="profile_picture" loading="lazy">
        </div>`;
        }
        else {
          templateHtml += `<div class="flex flex-0 items-center justify-center w-16 h-16 rounded-full overflow-hidden" title="${employeeName}">
        <div class="flex items-center justify-center w-full h-full rounded-md text-2xl uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
          ${employeeName?.slice(0, 1)} </div>
        </div>`;
        }
        templateHtml += `<div class='grid gap-0.5'><span class="font-medium tracking-wide text-lg">${employeeName}</span><span class="text-base text-gray-400">${role}</span></div></div><div class='flex gap-1'>`;
        templateHtml += `</div></div><hr>`;
        templateHtml += `<div class="flex flex-col justify-content my-2 space-y-2">
        <div class="flex flex-wrap items-center flex-row "><i class="ti ti-calendar text-2xl"></i>
        <div class="text-base mt-1 ml-1 flex items-center"><span>${timeoffRequestedFrom}</span><em class="ti ti-arrow-narrow-right text-xl mx-1"></em><span>${timeoffRequestedfromTo}</span></div></div>`;
    
        if (!this._utilityService.isEmptyOrUndefined(status)) {
          const timeoffStatusBadgeConfig: any = {
            type: status,
            displayName: this.getTimeOffStatusBatch(details),
            extraClass: 'text-xs'
          };
          templateHtml += `<div class="flex flex-row gap-4">
          <span class="w-1/4 text-base font-medium">${this._utilityService.getLocaleValue('status.text', 'Status')}</span>
          <span class="w-full text-base"><badge-template options='${JSON.stringify(timeoffStatusBadgeConfig)}'"></badge-template></span>
          </div>`;
        }
        if (!this._utilityService.isEmptyOrUndefined(reason)) {
          templateHtml += `<div class="flex flex-row gap-4"><span class="w-1/4 text-base font-medium">${this._utilityService.getLocaleValue('text.Reason', 'Reason')}</span>
          <span class="w-full text-base">${this.titlecasePipe.transform(reason)}</span></div>`;
        }
        if (!this._utilityService.isEmptyOrUndefined(remarks)) {
          templateHtml += `<div class="flex flex-row gap-4"><span class="w-1/4 text-base font-medium">${this._utilityService.getLocaleValue('text.remarks', 'Remarks')}</span>
          <span class="w-full text-base multiline-ellipsis">${remarks}</span></div>`;
        }
    
        templateHtml += `</div></div>`;
        break;
        case 'holiday':
          templateHtml = `<div class=" primary-fontflex flex-col px-2 py-1 w-full cursor-pointer">
          <div class="text-gray-900 truncate">
            Holiday: <span class="font-semibold">${details.holiday_name}</span>
          </div>
        </div>`;
        break;
    };
    return templateHtml;
  }

  getTimeoffStatus(timeoffDetails): any{
    let backgroundColor;
    switch (timeoffDetails.approval_status) {
      case 'APPROVED':
        backgroundColor = '#10B981';
        break;
        case 'REJECTED':
          backgroundColor = '#F87171';
        break;
        case 'AWAIT_APPROVAL':
          backgroundColor = '#FBBF24';
        break;
    }
    return backgroundColor;
  }

  getTimeOffStatusBatch(timeoffDetails): any{
    let batchText;
    switch (timeoffDetails.approval_status) {
      case 'APPROVED':
        batchText = this._utilityService.getLocaleValue(serviceContractStatus.APPROVED, 'Approved');
        break;
        case 'REJECTED':
          batchText = this._utilityService.getLocaleValue(serviceContractStatus.REJECTED, 'Rejected');
        break;
        case 'AWAIT_APPROVAL':
          batchText = this._utilityService.getLocaleValue(serviceContractStatus.AWAIT_APPROVAL, 'Pending');
        break;
    }
    return batchText;
  }

  getNonJobEventTooltip(nonJobEventDetails: any): string {
    let templateHTML: string = '';
    if (nonJobEventDetails) {
      const eventName: string = nonJobEventDetails?.event_name || '';
      const startEndTime: any[] = this._dispatchBoardService.getStartEndTime(nonJobEventDetails?.start_time, nonJobEventDetails?.end_time, false, null);
      const timezoneBasedStartEndTime: any[] = this._dispatchBoardService.getStartEndTime(nonJobEventDetails?.start_time, nonJobEventDetails?.end_time, false, null, false, false, nonJobEventDetails?.timezone);
      const timezoneCode: string = `GMT ${moment().tz(nonJobEventDetails?.timezone).format('Z')}`;
      const categoryColor: string = nonJobEventDetails?.event_category?.category_color || '#e67e22';
      const categoryName: string = nonJobEventDetails?.event_category?.category_name || '';
      const availabilityFree: boolean = nonJobEventDetails?.is_available;
      const eventAddress: string = this.getCityAddress(nonJobEventDetails?.event_address);
      const isRecurrence: boolean = nonJobEventDetails?.is_recurrence;
      const recurrenceText: string = isRecurrence ? nonJobEventDetails?.recurrence?.rrule ? this._utilityService.getRruleText(nonJobEventDetails?.recurrence?.rrule) : '': '';
      templateHTML += `
      <div class="w-full h-full">
        <div class="flex flex-col primary-font text-base fornt-normal text-gray-700">
          <div class="flex justify-between items-center space-x-1 truncate bg-gray-100 p-2 border-b border-gray-200">
            <span class="truncate block text-gray-500 font-medium">${eventName}</span>
            ${isRecurrence? `<i class="ti ti-repeat text-2xl" style="color: #0172CB"></i>`: ''}
          </div>
          <div class="flex flex-col space-y-3 primary-font text-base fornt-normal text-gray-700 p-3">
            <div class="flex flex-col space-y-1">
              <div class="flex items-start space-x-1.5">
                <i class="ti ti-calendar text-2xl"></i>
                <span>${startEndTime[0]}</span>
                <i class="ti ti-arrow-right text-2xl"></i>
                <span>${startEndTime[1]}</span>
              </div>
              <div class="flex items-start space-x-1.5 ml-6">
                (<span>${timezoneBasedStartEndTime[0]}</span>
                <i class="ti ti-arrow-right text-2xl"></i>
                <span>${timezoneBasedStartEndTime[1]} ${timezoneCode}</span>)
              </div>
            </div>
            ${isRecurrence? `<div class="flex items-start space-x-1.5">
              <i class="ti ti-repeat text-2xl"></i>
              <span>${this._utilityService.getLocaleValue('text.repeats')} ${recurrenceText}</span>
            </div>`: ''}
            <div class="flex items-start space-x-1.5">
              <i class="ti ti-layout-grid text-2xl"></i>
              <span>${categoryName}</span>
            </div>
            ${eventAddress ? `<div class="flex items-start space-x-1.5">
              <i class="ti ti-map-pin text-2xl"></i>
              <span>${eventAddress}</span>
            </div>`: ''}
            <div class="flex items-start space-x-1.5">
              <div class="w-2 h-6 mx-1.5 flex-0 border" style="${availabilityFree ? `background-image: linear-gradient(135deg, ${categoryColor} 25%, #ffffff 25%, #ffffff 50%, ${categoryColor} 50%, ${categoryColor} 75%, #ffffff 75%, #ffffff 100%); background-size: 11.31px 11.31px`: `background: ${categoryColor}`}; border-color: ${categoryColor}"></div>
              <span>${availabilityFree? this._utilityService.getLocaleValue('non_job_event.create.availability.free'): this._utilityService.getLocaleValue('non_job_event.create.availability.busy')}</span>
            </div>
          </div>
        </div>
      </div>
      `;
    }
    return templateHTML;
  }

  getJobDetailsTemplate(jobDetails: any, view: string, metaData: any): any {
    if (!jobDetails) {
      return '';
    }
    const badgeOption: any = jobDetails.current_job_status ? {
      type: jobDetails.current_job_status?.status_name,
      color: jobDetails.current_job_status?.status_color ?? badgeColorCode[jobDetails.current_job_status?.status_type] ?? null,
      displayName: jobDetails.current_job_status?.status_name,
      extraClass: 'capitalize'
    } : null;
    const cityAddress: string = this.getCityAddress(jobDetails.customer_address);
    const [scheduledStartDate] = this.getStartEndTime(jobDetails?.scheduled_start_time, jobDetails?.scheduled_end_time, this._utilityService.preferredTimeZone);
    let scheduledStartDateWithTimezone;
    if(jobDetails?.job_timezone){
       scheduledStartDateWithTimezone = this.getStartEndTime(jobDetails?.scheduled_start_time, jobDetails?.scheduled_end_time, jobDetails?.job_timezone);
    }
    return `<div class="flex flex-col job-preview-panel primary-font w-full">
      <div class="text-base font-bold flex py-1.5">
          #${jobDetails.prefix ?? ''}${jobDetails.work_order_number} ${jobDetails.job_title}
          ${jobDetails?.route?.route_uid ? `<span class="flex items-center ml-2">
              <em class="ti ti-road text-xl text-blue-700"></em>
          </span>` : ''}
          ${jobDetails.is_recurrence === true ? `<span class="flex items-center ml-2">
              <em class="ti ti-repeat text-xl text-blue-700"></em>
          </span>` : ''}
          ${jobDetails.delayed_job === true ? `<span class="flex items-center ml-2">
              <em class="ti ti-alarm text-xl text-red-700 mr-2"></em>
          </span>` : ''}
      </div>
  
      ${jobDetails.job_category ? `<div class="text-base flex py-1">
          <span class="flex items-center mr-2">
              <em class="ti ti-category text-xl"></em>
          </span>
          <div class="text-base flex items-center">
            ${jobDetails.job_category?.category_name}
            ${jobDetails.current_job_status ? `<badge-template class="ml-2" options='${JSON.stringify(badgeOption)}'></badge-template>` : ''}
          </div>
      </div>` : ''}
  
      ${jobDetails.startDate && jobDetails.endDate ? `<div class="text-base flex py-1">
          <span class="flex mt-0.5 mr-2">
              <em class="ti ti-calendar text-xl"></em>
          </span>
          <div class="text-base flex flex-wrap items-center">
          ${scheduledStartDate}
          </div>
      </div>` : ''}

       ${scheduledStartDateWithTimezone ? `<div class="text-base flex py-1">
          <div class="ml-6 text-base flex flex-wrap items-center">
          (${scheduledStartDateWithTimezone})
          </div>
      </div>` : ''}
  
      ${jobDetails.due_date ? `<div class="text-base flex py-1">
          <span class="flex items-center mr-2">
              <em class="ti ti-clock-hour-5 text-xl"></em>
          </span>
          ${this._utilityService.getLocaleValue('text.due_by', 'Due By')} : ${this.dateFormatPipe.transform(jobDetails.due_date)}
      </div>` : ''}

      ${jobDetails?.project && this.calendarService.moduleAccess.project ? `<div class="text-base flex py-1">
      <span class="flex items-center mr-2">
        <em class="ti ti-clipboard-check text-xl"></em>
      </span>
      ${this._utilityService.getLocaleValue('Project', 'Project')} : ${this.calendarService.getTitle(jobDetails?.project?.project_prefix, jobDetails?.project?.project_number, jobDetails?.project?.project_name)}
      </div>` : ''}
                                                                                  
      ${jobDetails.route && view === 'DAY' && metaData?.map?.enable_map_view ? `<div class="text-base flex py-1">
          <span class="flex items-center mr-2">
              <em class="ti ti-route text-xl"></em>
          </span>
          <div class="text-base flex items-center">
          ${this._utilityService.getLocaleValue('text.route', 'Route')} : ${jobDetails.route?.color ? `<span class="w-2.5 h-2.5 rounded-full mx-1" style="background:${jobDetails.route?.color};"></span>` : ''}${jobDetails.route?.route_name}
          </div>
      </div>` : ''}

      ${jobDetails.customer ? `<div class="text-base flex py-1">
          <span class="flex items-center mr-2">
              <em class="ti ti-user text-xl"></em>
          </span>
          ${jobDetails.customer.customer_first_name + ' ' + (jobDetails.customer.customer_last_name || '')}
          ${jobDetails.customer.customer_organization ? `<span class="ml-1">(${jobDetails.customer.customer_organization.organization_name})</span>` : ''}
      </div>` : ''}

      ${!jobDetails.customer && jobDetails.organization ? `<div class="text-base flex py-1">
          <span class="flex items-center mr-2">
              <em class="ti ti-building text-xl"></em>
          </span>
          ${jobDetails.organization?.organization_name}
      </div>` : ''}

      ${jobDetails.customer_address?.street ? `<div class="text-base flex py-1">
          <span class="flex mt-0.5 mr-2">
              <em class="ti ti-map-pin text-xl"></em>
          </span>
          ${this._utilityService.getUniqueStreetValue(jobDetails.customer_address)}
      </div>` : ''}

       ${jobDetails.service_territory?.territory ? `<div class="text-base flex py-1">
          <span class="flex mt-0.5 mr-2">
              <em class="ti ti-compass text-xl"></em>
          </span>
          ${jobDetails.service_territory?.territory?.territory_name ?? '--'}
      </div>` : ''}
  
      ${cityAddress ? `<div class="text-base flex py-1">
          <span class="flex mt-0.5 mr-2">
              <em class="ti ti-location text-lg"></em>
          </span>
          ${cityAddress}
      </div>` : ''}
      </div>`;

  }

  getStartEndTime(startDateTime: any, endDateTime: any, timezone: string): any[] {
    if (!startDateTime || !endDateTime) {
        return [null, null];
    }
    let dateTimeFormatTimezone;
    let timeFormatTimezone;

    if(timezone){
      startDateTime = dayjs(startDateTime).tz(timezone);
      endDateTime = dayjs(endDateTime).tz(timezone);
      dateTimeFormatTimezone = `${this._utilityService.dateTimeFormat} z`;
      timeFormatTimezone = `${this._utilityService.timeFormat} z`;
    } else{
      startDateTime = dayjs(startDateTime);
      endDateTime = dayjs(endDateTime);
      dateTimeFormatTimezone = this._utilityService.dateTimeFormat;
      timeFormatTimezone = this._utilityService.timeFormat;
    }

    const dateTimeFormat = this._utilityService.dateTimeFormat;

    let startDate: string;
    let endDate: string;
    let formattedEndTime: string;

    if (startDateTime.isSame(endDateTime, 'date')) {
        startDate = dayjs(startDateTime).format(`${dateTimeFormat}`);
        endDate = dayjs(endDateTime).format(timeFormatTimezone);
        formattedEndTime = `${startDate} - ${endDate}`;
    } else {
        startDate = dayjs(startDateTime).format(`${dateTimeFormat}`);
        endDate = dayjs(endDateTime).format(`${dateTimeFormatTimezone}`);
        formattedEndTime = `${startDate} - ${endDate}`;
    }

    return [formattedEndTime];
  }

  async getEmployeePreviewTemplate(tab: 'jobs' | 'routes', dateRange: { fromDate: string; toDate: string } = null, userDetails: any = null, preferences: any = null, eventCount: any = null, viewMode: string = null): Promise<string> {
    this.dateRange = dateRange;
    this.userDetails = userDetails;
    this.preferences = preferences;
    this.viewMode = viewMode;
    this.fieldsVisibility = this.preferences?.display;
    const userUid = this.userDetails?.user_uid;
    let workMins: number;
    let availableMins: number;
    if (this.viewMode === 'DAY' && this.fieldsVisibility?.capacity) {
      [workMins, availableMins] = await this.getUserCapacity(userUid, dateRange.fromDate, dateRange.toDate);
    }
    this.updateTimeSheetValue();
    this.updateCapacityHours(workMins, availableMins);

    let templateHtml = '';
    if (!this._utilityService.isEmptyOrUndefined(this.userDetails)) {
      templateHtml += `<div class="flex flex-col employee-preview-panel primary-font">`;
      templateHtml += `<div>
    <div class="flex items-center pb-3 border-b">
        <div class="inline-flex overflow-hidden rounded-md flex-shrink-0">`;
      if (this._utilityService.hasValidProfilePicture(userDetails.profile_picture)) {
        templateHtml += `<img
      class="h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12"
      src="${userDetails.profile_picture}" alt="">`;
      }
      if (!this._utilityService.hasValidProfilePicture(userDetails.profile_picture) && userDetails.first_name) {
        templateHtml += `<div 
        class="flex items-center justify-center overflow-hidden uppercase text-4xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 h-10 w-10 flex-shrink-0 sm:h-9 sm:w-9 lg:h-12 lg:w-12">
        ${userDetails.first_name[0]}
    </div>`;
      }
      templateHtml += `</div>`;
      templateHtml += `<div class="m-2 sm:ml-3 sm:flex-1 break-all max-w-2/4">
      <div class="flex items-center">
          <h3 class="text-lg font-bold text-gray-600 sm:text-1xl truncate max-w-3/4">
              ${userDetails.first_name} ${userDetails.last_name ?? ''}</h3>
      </div>`;
      if (userDetails.designation) {
        templateHtml += `<div>`;
        templateHtml += `<span class="text-gray-500 text-base truncate">
        ${userDetails.designation}</span>`;
        if (this.fieldsVisibility?.role && userDetails?.role?.role_name) {
          templateHtml += `<span 
          class="text-gray-500 text-base truncate">
          (${userDetails?.role?.role_name})</span>`;
        }

        if (this.fieldsVisibility?.capacity && viewMode === 'DAY' && this.capacityHours) {
          templateHtml += `<br><span class="text-gray-500 text-base truncate">
          ${this.capacityHours?.hours ? this.capacityHours?.hours + 'h' : ''} ${this.capacityHours?.minutes ?
              this.capacityHours?.minutes + 'm' : ''} ${this.capacityHours?.hours || this.capacityHours?.minutes ? 'remaining - ' : ''}${this.getCapacityPercentage(workMins, availableMins) + '%'}</span>`;
        }
        templateHtml += `</div>`;
      }

      templateHtml += `</div>`;
      templateHtml += `<div class="flex ml-auto items-center">`;
      if (userDetails?.email) {
        templateHtml += `<a href="mailto:${userDetails?.email}" title="${this._utilityService.getLocaleValue('tooltip.email.text')}"
        class="flex flex-shrink-0 hover:bg-gray-100 rounded-lg items-center justify-center h-8 w-8 cursor-pointer">
        <i class="ti ti-mail text-gray-800 text-xl"></i>
        </a>`;
      }
      if (userDetails?.mobile_phone_number || userDetails?.work_phone_number || userDetails?.home_phone_number) {
        templateHtml += `
        <a href="tel:${userDetails?.mobile_phone_number || userDetails?.work_phone_number || userDetails?.home_phone_number}"
            title="${this._utilityService.getLocaleValue('tooltip.contact.text')}"
            class="flex flex-shrink-0 hover:bg-gray-100 rounded-lg items-center justify-center h-8 w-8 cursor-pointer">
            <i class="ti ti-phone text-gray-800 text-xl"></i>
        </a>`;
      }
      templateHtml += `<a target="_blank" id='employeeDetailsExternal' data-useruid="${userDetails.user_uid}" 
          title="${this._utilityService.getLocaleValue('employee.preview.view.details')}"
          class="flex flex-shrink-0 hover:bg-gray-100 rounded-lg items-center justify-center h-8 w-8 cursor-pointer">
          <i class="ti ti ti-id text-gray-800 text-xl"></i>
      </a>`;
      templateHtml += `</div>`;
      templateHtml += `</div>`;

      templateHtml += `<div>`;
      templateHtml += `<div class="flex py-4 primary-font">
      <span class="w-1/3 text-base">${tab === 'jobs' ? this._utilityService.getLocaleValue('employee.preview.jobs.label') : this._utilityService.getLocaleValue('dispatchBoard.tab.routes')}</span>
        <div class="flex items-center w-2/3">
            <em class="ti ti-briefcase text-xl mr-1"></em>
            <div class="text-base">
                ${eventCount || 0}
            </div>
            </div>
        </div>`;
      if (this.fieldsVisibility?.timesheet_status && (this.timeSheetValue?.punchedIn || this.timeSheetValue?.punchedOut)) {
        templateHtml += `<div class="flex my-2.5 mx-5 primary-font"> <span class="w-1/3 text-base">${this._utilityService.getLocaleValue('employee.preview.timesheet.label')}</span>`;
        templateHtml += ` <div class="flex flex-col w-2/3">`;
        if (this.timeSheetValue?.punchedIn) {
          templateHtml += `<div class="flex mb-2">
          <em class="ti ti-clock-hour-9 text-xl mr-1"></em>
          <div class="text-base">
              ${this._utilityService.getLocaleValue('employee.preview.punched_in.label')} - <span>${this.dateTimePipe.transform(this.timeSheetValue.punchedIn)}</span>
          </div>
      </div>`;
        }
        if (this.timeSheetValue?.punchedOut) {
          templateHtml += `<div class="flex mb-2">
          <em class="ti ti-clock-hour-9 text-xl mr-1"></em>
          <div class="text-base">
              ${this._utilityService.getLocaleValue('employee.preview.punched_out.label')} - <span>${this.dateTimePipe.transform(this.timeSheetValue.punchedOut)}</span>
          </div>
      </div>`;
        }
        templateHtml += `</div>`;
        templateHtml += `</div>`;
      }
      if (this.fieldsVisibility?.skillset && userDetails.user_skills?.length) {
        templateHtml += `<div class="flex my-2.5 primary-font">`;
        templateHtml += `<span class="w-1/3 text-base">${this._utilityService.getLocaleValue('employee.preview.skill.label')}</span>`;
        templateHtml += ` <div class="flex items-center -mt-2 w-2/3">`;
        templateHtml += `<ul role="list" class="w-full divide-y divide-gray-200">`;
        userDetails.user_skills?.forEach((skill: any) => {
          templateHtml += `<li class="py-2 space-y-1.5 w-full text-base primary-font">`;
          templateHtml += `<p class="font-medium">
          ${skill.skillsets?.skillset_name ?? ''}
          </p>`;
          templateHtml += `<div class="w-2/4 rounded h-1.5 bg-gray-200">
          <div class="h-full rounded ${(skill.skill_level || 0) > 20 ? 'bg-blue-800' : ''} ${(skill.skill_level || 0) <= 20 ? 'bg-red-500' : ''}" style="width: ${(skill.skill_level || 0)}%"
              title="${(skill.skill_level || 0) + '%'}">
            </div>
          </div>`;
          if (skill.end_date && this.isExpired(skill.end_date)) {
            templateHtml += `<p class="text-base text-red-500">
            ${this._utilityService.getLocaleValue('employee.preview.panel.expired')}
          </p>`;
          }
          if (skill.end_date && !this.isExpired(skill.end_date)) {
            templateHtml += `<p class="text-md text-gray-500">
            ${this._utilityService.getLocaleValue('text.expires_on')} ${this.dateFormatPipe.transform(skill.end_date)}
            </p>`;
          }
          templateHtml += `</li>`;
        });
        templateHtml += `</ul>`;
        templateHtml += `</div>`;
        templateHtml += `</div>`;
      }
      if (this.fieldsVisibility?.work_hours && viewMode === 'DAY' && userDetails.work_hours?.length && this.getWorkHours()) {
        templateHtml += `
        <div class="flex py-4 primary-font">
                <span class="w-1/3 text-base">${this._utilityService.getLocaleValue('employee.preview.work_hours.label')}</span>
                <div class="flex items-center w-2/3">
                    <em class="ti ti-clock text-xl mr-1"></em>
                    <div class="text-base">
                        ${this.getWorkHours()}
                    </div>
                </div>
            </div>`;
      }
      templateHtml += `</div>`;
      templateHtml += `</div>`;
      templateHtml += `</div>`;
    }
    return templateHtml;
  }

  getRouteEventHeaderTemplate(routeDetails: any): string {
    const routeName = routeDetails?.route_name || '';
    const routeColor = routeDetails?.color || '#ffffff';
    const isRouteLocked = routeDetails?.is_locked;
    let templateHtml = '';
    templateHtml = `<div class="flex flex-row space-x-1.5 items-center text-black">
        <div class="w-3 h-3 rounded-full" style='background-color: ${routeColor}'></div>
        <span class="text-base font-medium">${routeName}</span>
        ${isRouteLocked? `<i class='ti ti-lock text-xl font-normal' title='${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.locked')}'></i>`: ''}
      </div>`;
    return templateHtml;
  }

  getRouteTravelDistanceTooltipTemplate(jobDetails: any, type: 'preamble' | 'postamble'): string {
    let travelTime: number;
    let travelDistance: number;
    if (type === 'preamble') {
      travelTime = jobDetails.time || 0;
      travelDistance = jobDetails.distance || 0;
    }
    else if (type === 'postamble') {
      travelTime = jobDetails.end_location_time || 0;
      travelDistance = jobDetails.end_location_distance || 0;
    }
    const modeOfTransport = jobDetails.transport_mode || 'CAR';
    const time: string = this._utilityService.convertSecondsToHours(travelTime);
    const distance: string = this._utilityService.getDistance(travelDistance);
    const distanceUnit: string = this._utilityService.companyConfig?.general?.distance_metric === 'MILES' ? this._utilityService.getLocaleValue('route.distance.metric.miles') : this._utilityService.getLocaleValue('route.distance.metric.kilo_meters');
    const templateHTML = `<div class="h-full w-full text-base font-normal space-y-1">
    <div class="flex items-center">
      <span class="font-medium">${this._utilityService.getLocaleValue('text.mode_of_transport', 'Mode of Transport')} : </span>
      <i class="${modeOfTransport === 'Car' ? 'ti ti-car' : modeOfTransport === 'Truck' ? 'ti ti-truck' : 'ti ti-walk'} text-xl mx-1"></i>
      <span>${this.titlecasePipe.transform(modeOfTransport)}</span>
    </div>
    <div class="flex items-center">
      <span class="font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.tooltip.travel_distance', 'Travel Distance')} : </span>
      <span class='ml-1'>${distance} ${distanceUnit}</span>
    </div>
    <div class="flex items-center">
      <span class="font-medium">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.tooltip.travel_time', 'Travel Time')} : </span>
      <span class='ml-1'>${time}</span>
    </div>
  </div>`;
    return templateHTML;
  }

  getTableProxyView(viewObj: any): any {
    const MAX_COLUMN = 2;
    const viewObjChunks = _.chunk(viewObj, MAX_COLUMN);
    const proxyCardView = {};
    viewObjChunks?.forEach((rowData: any, index) => {
      proxyCardView[index + 1] = rowData;
    });

    return proxyCardView;
  }

  getCardColor(jobDetails: any, category: JobColorType): string {
    let colorCode: string = '';
    if (category === 'jobStatus') {
      colorCode = jobDetails?.current_job_status?.status_color;
    }
    else if (category === 'jobPriority') {
      const priority = jobDetails?.job_priority;
      colorCode = badgeColorCode[priority] || '#887ECB';
    }
    else if (category === 'jobCategory') {
      colorCode = jobDetails?.job_category?.category_color;
    }
    else if (category === 'team') {
      const assignedTo = jobDetails?.assigned_to;
      if (assignedTo?.length > 0) {
        colorCode = assignedTo[0]?.team?.team_color;
      }
    }
    else if (category === 'none') {
      colorCode = '#ffffff';
    }
    return colorCode;
  }

  getGridColorTooltip(jobDetails: any, category: JobColorType): any {
    let tooltipValue: string = '';
    if (category === 'jobStatus') {
      tooltipValue = jobDetails?.current_job_status?.status_name;
    }
    else if (category === 'jobPriority') {
      tooltipValue = this.titlecasePipe.transform(jobDetails?.job_priority || '');
    }
    else if (category === 'jobCategory') {
      tooltipValue = jobDetails?.job_category?.category_name;
    }
    else if (category === 'team') {
      const assignedTo = jobDetails?.assigned_to;
      if (assignedTo?.length > 0) {
        tooltipValue = assignedTo[0]?.team?.team_name;
      }
    }

    return tooltipValue;
  }

  getRouteDetailsTooltipTemplate(routeDetails: any): string {
    const routeName = routeDetails?.route_name || '';
    const routeColor = routeDetails?.color || '#ffffff';
    const modeOfTransport = this.titlecasePipe.transform(routeDetails.transport_mode || 'CAR');
    const distanceUnit: string = this._utilityService.companyConfig?.general?.distance_metric === 'MILES' ? this._utilityService.getLocaleValue('route.distance.metric.miles') : this._utilityService.getLocaleValue('route.distance.metric.kilo_meters');
    const routeType = this.titlecasePipe.transform(routeDetails?.route_type || 'FASTEST');
    const duration = routeDetails?.duration || 1;
    const routeStartDateTime = moment.utc(routeDetails?.departure);
    const routeEndDateTime = routeStartDateTime.clone().add(duration, 'h');
    const routeStartEndTime = this._dispatchBoardService.getStartEndTime(routeStartDateTime, routeEndDateTime, false);
    const totalDistance = this._utilityService.getDistance(routeDetails?.total_distance || 0);
    const totalHour = this._utilityService.getHours(routeDetails?.total_time || 0);
    const totalMin = this._utilityService.getMin(routeDetails?.total_time || 0);
    const totalJobs = routeDetails?.total_jobs || 0;
    const assignedTo = routeDetails?.assigned_to;
    const isLocked = routeDetails?.is_locked;
    const formatedAssignedTo = this._dispatchBoardService.getAssignedNameAndCount(assignedTo);
    let templateHTML: string = '';
    templateHTML += `<div class='flex flex-col primary-font w-full h-full text-base font-normal text-gray-700 space-y-1'>`;
    templateHTML += `<div class='w-full flex space-x-1.5 items-center justify-center'><div><div class='w-3 h-3 rounded-full' style='background-color: ${routeColor}'></div></div><span class='font-semibold' title='${this._utilityService.getLocaleValue('dispatchBoard.routes.tooltip.title', 'Route Name')} : ${routeName}'>${routeName}</span>${isLocked? `<i class='ti ti-lock text-xl font-normal' title='${this._utilityService.getLocaleValue('dispatchBoard.scheduler.route.locked')}'></i>`: ''}</div>`;
    templateHTML += `<div class='w-full flex items-center space-x-2'> 
    <div class='flex items-center'> <i class="${modeOfTransport === 'Car' ? 'ti ti-car' : modeOfTransport === 'Truck' ? 'ti ti-truck' : 'ti ti-walk'} text-xl mx-1"></i><span title='${this._utilityService.getLocaleValue('text.mode_of_transport', 'Mode of Transport')} : ${modeOfTransport}'>${modeOfTransport}</span></div>
    <div class='flex items-center'> <i class="ti ti-route text-xl mx-1"></i><span title='${this._utilityService.getLocaleValue('dispatchBoard.routes.tooltip.route_type', 'Route Type')} : ${routeType}'>${routeType}</span></div>
    </div>`;
    templateHTML += `<div class='w-full flex items-center space-x-2'><div class='flex items-center'><i class='ti ti-clock text-xl mx-1'></i> <span title='${this._utilityService.getLocaleValue('label.total_time', 'Total Time')}'>${totalHour ? totalHour : ''} ${totalHour ? this._utilityService.getLocaleValue('route.hours') : ''} ${totalMin ? totalMin : ''} ${totalMin ? this._utilityService.getLocaleValue('route.min') : ''}</span></div>`;
    templateHTML += `<div class='flex items-center'><i class='ti ti-timeline text-xl mx-1'></i> <span title='${this._utilityService.getLocaleValue('text.total_distance', 'Total Distance')}'>${totalDistance} ${distanceUnit}</span></div>`;
    templateHTML += `</div>`;
    templateHTML += `<div class='w-full flex items-center space-x-2'> 
    <div class='flex items-center'> <i class="ti ${assignedTo.length <= 1 ? 'ti-user' : 'ti-users'} text-xl mx-1"></i><span title='${this._utilityService.getLocaleValue('assigned.to.label', 'Assigned To')} : ${formatedAssignedTo}'>${formatedAssignedTo}</span></div>
    <div class='flex items-center'> <i class="ti ti-briefcase text-xl mx-1"></i><span title='${this._utilityService.getLocaleValue('text.no_of_jobs', 'No of Jobs')} : ${totalJobs}'>${totalJobs}</span></div>
    </div>`;
    templateHTML += `<div class='w-full flex items-center'> 
    <div class='flex items-center'><i class='ti ti-calendar-time text-xl mx-1'></i> <span>${routeStartEndTime[0]}</span><i class='ti ti-arrow-narrow-right text-xl mx-1'></i><span>${routeStartEndTime[1]}</span></div>
    </div>`;
    templateHTML += `</div>`;
    return templateHTML;
  }

  counter(i: number): any[] {
    return Array(i).fill(1).map((x, value) => value + 1);
  }

  getTableDefaultFieldColumn(key: any, column: any): any {
    let rendererHTML: string;
    switch (key) {
      case 'work_order_skillsets': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value?.skill_name) {
            rendererHTML = `
            <div class="flex gap-1">
            <span class="bg-blue-100 text-blue-800 text-base font-medium max-w-48 break-all min-w-8 mr-2 px-2 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">${value?.skill_name}</span>
            `;
            if (value?.skill_count > 0) {
              rendererHTML += `<span class="bg-blue-100 text-blue-800 text-base font-medium max-w-48 break-all min-w-8 mr-2 px-2 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300">+ ${value?.skill_count} more</span>
            </div>`;
            }
            else {
              rendererHTML += `</div>`;
            }
          }
          return rendererHTML;
        };
      }

      case 'current_work_order_status': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value) {
            rendererHTML = `
            <span class="text-white text-base font-medium max-w-48 break-all min-w-8 mr-2 px-2 py-0.5 rounded dark:bg-blue-900 dark:text-blue-300" style="background-color: ${record?.record.data.status_color_selector}">${value}</span>
            `;
          }
          return rendererHTML;
        };
      }

      case 'work_order_priority': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          const priorityColor = badgeColorCode[value] || '#ffffff';
          rendererHTML = '-';
          if (value) {
            rendererHTML = `
            <div class ='flex items-center gap-1'><div class='w-3 h-3 rounded-full' style='background-color:${priorityColor};'></div>
            <span class='overflow-hidden whitespace-nowrap text-ellipsis w-fit'>${this.titlecasePipe.transform(value)}</span></div>
            `;
          }
          return rendererHTML;
        };
      }

      case 'work_order_assigned_to': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value?.count !== -1) {
            rendererHTML = `<div class="overflow-hidden whitespace-nowrap text-ellipsis w-fit font-normal text-base mr-2">${value?.name}</div>`;
            if (value?.count > 0) {
              rendererHTML += `
              <div class="overflow-hidden whitespace-nowrap text-ellipsis w-fit font-normal text-base">
                      +${value?.count} ${this._utilityService.getLocaleValue('text.more', 'more')}
              </div>`;
            }
          }
          return rendererHTML;
        };
      }

      case 'work_order_title': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value) {
            rendererHTML = `<span class='overflow-hidden whitespace-nowrap text-ellipsis w-fit font-normal text-base'>${value}</span>`;
            if (record?.record.data?.routeJob) {
              rendererHTML += `<em title="${this._utilityService.getLocaleValue('dispatchBoard.template.grid.route_job', 'Route Job')}" class="ti ti-road text-2xl text-blue-700 ml-2"></em>`;
            }
            if (record?.record.data.is_recurrence) {
              rendererHTML += `<em title="${this._utilityService.getLocaleValue('text.recurrent_job', 'Recurrent Job')}" class="ti ti-repeat text-2xl text-blue-700 ml-2"></em>`;
            }
            if (record?.record.data.delayed_job) {
              rendererHTML += `<em title="${this._utilityService.getLocaleValue('dispatchBoard.template.grid.delay_job', 'Delay Job')}" class="ti ti-alarm text-2xl text-red-700 mr-2"></em>`;
            }
          }
          return rendererHTML;
        };
      }

      case 'work_order_actual_date':
      case 'work_order_scheduled_date': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value) {
            rendererHTML = `<div class="flex gap-2 text-base font-normal text-gray-700 overflow-hidden whitespace-nowrap text-ellipsis w-fit"><span
            class="overflow-hidden whitespace-nowrap font-normal text-ellipsis w-fit">${value.startDateTime} ${value.endDateTime ? `<i class='ti ti-arrow-narrow-right text-xl mx-1'></i> ${value.endDateTime}` : ``}</div>`;
          }
          return rendererHTML;
        };
      }

      case 'total_jobs': {
        return (record: any): any => {
          const value = record.record?.data[column.key] ?? '-';
          rendererHTML = `<div class="overflow-hidden whitespace-nowrap text-ellipsis w-fit font-normal text-base mr-2">${value}</div>`;
          return rendererHTML;
        };
      }

      default: {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value) {
            rendererHTML = `<span class='text-base font-normal'>${value}</span>`;
          }
          return rendererHTML;
        };
      }
    }
  }

  getTableCustomFieldColumn(type: any, column: any): any {
    let rendererHTML: string;
    switch (type) {
      case 'SINGLE_LINE':
      case 'TEXT':
        {
          return (record: any): any => {
            const value = record.record?.data[column.key];
            rendererHTML = '-';
            if (value?.href) {
              rendererHTML = `
            <a class="flex w-10/12 text-justify text-primary-500 hover:underline font-normal text-base" 
                href="${value?.href}" target="_blank" onclick="event.stopPropagation()">${this._utilityService.getLocaleValue('dispatchBoard.grid.open_link.title')}</a>`;
            }
            else {
              rendererHTML = `<span>${value ? value : '-'}</span>`;
            }
            return rendererHTML;
          };
        }

      case 'FILE': {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value?.href?.length > 1) {
            rendererHTML = `
            <span >
              <a class="flex w-10/12 text-justify text-primary-500 hover:underline font-normal text-base" 
                          href="${value?.href}" target="_blank" onclick="event.stopPropagation()">${this._utilityService.getLocaleValue('dispatchBoard.grid.open_link.title')}</a>
            </span>`;
          }
          return rendererHTML;
        };
      }

      case 'LOOKUP': {
        return (record: any): any => {
          const value = record?.record.data[column.key];
          rendererHTML = '-';
          if (value?.href) {
            rendererHTML = `
            <span>
            <a class="flex w-10/12 text-justify text-primary-500 hover:underline font-normal text-base" 
            href="${value?.href}" target="_blank" onclick="event.stopPropagation()">${value?.value}</a>
            </span>`;
          }
          return rendererHTML;
        };
      }

      default: {
        return (record: any): any => {
          const value = record.record?.data[column.key];
          rendererHTML = '-';
          if (value) {
            rendererHTML = `<span class='overflow-hidden whitespace-nowrap text-ellipsis w-fit font-normal text-base'>${value}</span>`;
          }
          return rendererHTML;
        };
      }

    }
  }

  getCityAddress(address: any): string {
    const addressArray: string[] = [];
    if (address?.name) {
      addressArray.push(address.name);
    }
    if (address?.street) {
      addressArray.push(address.street);
    }
    if (address?.landmark) {
      addressArray.push(address.landmark);
    }
    if (address?.city) {
      addressArray.push(address.city);
    }
    if (address?.state) {
      addressArray.push(address.state);
    }
    if (address?.zip_code) {
      addressArray.push(address.zip_code);
    }
    return addressArray.length > 0 ? addressArray.join(', ') : '';
  }

  updateTimeSheetValue(): void {
    if (this.viewMode === 'DAY' && this.userDetails?.timesheet?.length) {
      const timesheet: any[] = this.userDetails?.timesheet;
      const punchedOutIndex: number = timesheet?.lastIndexOf((value: any) => value.type_of_check === 'CHECK_OUT');
      this.timeSheetValue = {
        punchedIn: timesheet?.find((value: any) => value.type_of_check === 'CHECK_IN')?.checked_time ?? null,
        punchedOut: punchedOutIndex > -1 ? (timesheet?.[punchedOutIndex]?.checked_time || null) : null
      };
    }
  }

  updateCapacityHours(workMins: number, availableMins: number): void {
    if (this.viewMode === 'DAY' && workMins) {
      let capacity: number = 0;
      if (workMins) {
        capacity = Math.trunc((workMins - availableMins) > 0 ? (workMins - availableMins) : (workMins || 0));
      }
      this.capacityHours = this._utilityService.getTimeLogValue(availableMins);
    }
  }

  //Date time should be in IST (YYYY-MM-DD)
  getUserCapacity(userUid: string, fromDate: string, toDate: string): Promise<number[]> {
    const fromDateTime = fromDate + ' 00:00:00';
    const toDateTime = toDate + ' 23:59:59';
    const userAvailabilityPayload = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      from_date_time: fromDateTime, to_date_time: toDateTime, user_uid: userUid
    };
    return new Promise((resolve, reject) => {
      this._dataCollectorService.getData(this._dispatchBoardService.userAvailabilityUrl, userAvailabilityPayload)
        .subscribe((response) => {
          const data = response?.data || [];
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const userCapacity = _.find(data, { 'user_uid': userUid });
          if (userCapacity) {
            const availableMins = userCapacity?.work_mins.available_mins || 0;
            const workMins = userCapacity?.work_mins.work_mins || 0;
            resolve([workMins, availableMins]);
          }
          else {
            resolve([0, 0]);
          }
        }, (error) => {
          resolve([0, 0]);
        });
    });
  }

  getCapacityPercentage(workMins: number, availableMins: number): number {
    if (this.viewMode === 'DAY' && availableMins && workMins) {
      return 100 - Math.trunc((availableMins / workMins) * 100);
    }
    return 0;
  }

  getWorkHours(): string {
    if (this.dateRange.fromDate) {
      const workingDay: string = dayjs(this.dateRange.fromDate).format('dddd');
      const userWorkingDay: any = this.userDetails.work_hours?.find((day: any) => day.day === workingDay);
      if (userWorkingDay?.start_time && userWorkingDay?.end_time) {
        return this.timePipe.transform(userWorkingDay?.start_time, false, 'HH:mm:ss') + ' - ' + this.timePipe.transform(userWorkingDay?.end_time, false, 'HH:mm:ss');
      }
    }
    return '';
  }

  isExpired(date: string): boolean {
    return dayjs(date).isBefore(dayjs());
  }

  previewClose(): void {
    this.previewEmitter.emit({ isPreviewClosed: true });
  }
}
export type TemplateType = 'jobGridCard' | 'routeGridCard' | 'scheduler' | 'employee' | 'tableProxy' | 'calendar';
export type JobColorType = 'jobStatus' | 'team' | 'jobCategory' | 'jobPriority' | 'none';

